import * as config from '@/config.json'

import { copyToClipboard } from '../../functions/functions'

import Loading from 'vue-loading-overlay'
import LoadingComp from '../../components/LoadingComp.vue'
import TableSkeleton from '../../components/TableSkeleton.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import axios from 'axios'

export default {
  name: 'GatewayValidationRegister',
  components: {
    Loading,
    LoadingComp,
    TableSkeleton,
    VueQrcode
  },
  data() {
    return {
      isLoading: false,
      token: '',
      items: [],
      fields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'appName',
          label: 'Aplicativo'
        },
        {
          key: 'name',
          label: 'Nome'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'partnerName',
          label: 'Parceiro'
        },
        {
          key: 'type',
          label: 'Tipo'
        },
        {
          key: 'baseUrl',
          label: 'URL Base'
        },
        {
          key: 'gatewayInstanceName',
          label: 'Nome Instância'
        },
        {
          key: 'firebaseToken',
          label: 'Firebase Token'
        },
        {
          key: 'isActive',
          label: 'Status'
        },
        {
          key: 'actions',
          label: 'Ações'
        }
      ],
      isBusy: false,
      selectedAppOption: null,
      optionsApp: [],
      showStatusModal: false,
      showSendTestMessageModal: false,
      showLogoutModal: false,
      showConnectModal: false,
      statusData: null,
      logoutData: null,
      connectData: null,
      selectedGateway: null,
      isLoadingStatus: false,
      isLoadingLogout: false,
      isLoadingConnect: false,
      isLoadingSendTestMessage: false,
      sendTestMessageData: null,
      formTestMessage: {
        number: '',
        message: ''
      }
    }
  },

  methods: {
    redirect(ref) {
      this.$router.push(`/${ref}`)
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type
      })
    },

    focus(id) {
      const el = document.getElementById(id)
      if (!el) return
      if (id === 'test-number') {
        const input = el.querySelector('input') || this.$refs.testNumberInput?.$el?.querySelector('input')
        if (input) {
          input.focus()
          return
        }
      }
      el.focus()
    },

    onPhoneInput(value) {
      if (value) {
        const validPhoneRegex = /^[+\d\s\-()]+$/

        if (!validPhoneRegex.test(value)) {
          this.$nextTick(() => {
            this.formTestMessage.number = this.formTestMessage.number.replace(/[^+\d\s\-()]/g, '')
          })
          return
        }

        const cleanedValue = value.replace(/[^+\d\s\-()]/g, '')
        this.formTestMessage.number = cleanedValue
      } else {
        this.formTestMessage.number = value
      }
    },

    async copyId(data) {
      await copyToClipboard(data.item.id)

      this.getNotification('Sucesso', 'ID copiado.', 'success')
    },

    async copyFirebaseToken(data) {
      await copyToClipboard(data.item.firebaseToken)

      this.getNotification('Sucesso', 'Firebase Token copiado.', 'success')
    },

    async copyUrl(data) {
      await copyToClipboard(data.item.baseUrl)

      this.getNotification('Sucesso', 'URL copiada.', 'success')
    },

    async copyInstanceName(data) {
      await copyToClipboard(data.item.gatewayInstanceName)

      this.getNotification('Sucesso', 'Nome da Instância copiado.', 'success')
    },

    async copyIdFromCard(gateway) {
      await copyToClipboard(gateway.id)

      this.getNotification('Sucesso', 'ID copiado.', 'success')
    },

    async copyFirebaseTokenFromCard(gateway) {
      await copyToClipboard(gateway.firebaseToken)

      this.getNotification('Sucesso', 'Firebase Token copiado.', 'success')
    },

    async copyUrlFromCard(gateway) {
      await copyToClipboard(gateway.baseUrl)

      this.getNotification('Sucesso', 'URL copiada.', 'success')
    },

    async copyInstanceNameFromCard(gateway) {
      await copyToClipboard(gateway.gatewayInstanceName)

      this.getNotification('Sucesso', 'Nome da Instância copiado.', 'success')
    },

    clearAppFilter() {
      this.selectedAppOption = null
      this.items = []
      this.focus('app')
    },

    async getValidationRegisterGateways() {
      if (!this.selectedAppOption) {
        return
      }

      this.isBusy = true

      const url = `${config.default.urlBase}/customer-validation-register-gateways`
      const data = {
        appId: this.selectedAppOption
      }

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isBusy = false

          this.items = response.data
        }
      } catch (error) {
        console.log({
          error
        })

        this.isBusy = false
        this.isLoading = false

        this.items = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response.status == 400) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        }

        if (error.response.status == 401) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        }
      }
    },

    async getApps() {
      const url = `${config.default.urlBase}/apps/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        this.selectedAppOption = null
        this.optionsApp = []

        if (response.status == 200) {
          this.optionsApp = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} - ${item.name}`
              }
            })
          )

          if (this.optionsApp.length == 1) {
            this.selectedAppOption = this.optionsApp[0].value
            await this.getValidationRegisterGateways()
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.optionsApp = []
        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os aplicativos! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getInstanceStatus(gateway) {
      this.selectedGateway = gateway
      this.isLoadingStatus = true
      this.showStatusModal = true
      this.statusData = null

      const url = `${config.default.urlBase}/evolution-api/instance/status`
      const data = {
        url: gateway.baseUrl,
        apikey: gateway.apiKey
      }

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.statusData = response.data[0] || response.data
          this.isLoadingStatus = false
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoadingStatus = false

        if (!error.response) {
          this.getNotification('Erro', 'Não foi possível conectar-se ao servidor.', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.getNotification('Erro', `${error.response.data.message || 'Erro ao buscar status da instância'}`, 'error')
        }
      }
    },

    async logoutInstance(gateway) {
      const confirmed = await this.$bvModal.msgBoxConfirm(`Tem certeza que deseja desconectar a instância "${gateway.gatewayInstanceName}"?`, {
        title: 'Confirmar Desconexão',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Sim, Desconectar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })

      if (!confirmed) {
        return
      }

      this.selectedGateway = gateway
      this.isLoadingLogout = true
      this.showLogoutModal = true
      this.logoutData = null

      const url = `${config.default.urlBase}/evolution-api/instance/logout`
      const data = {
        url: gateway.baseUrl,
        apikey: gateway.apiKey,
        instanceName: gateway.gatewayInstanceName
      }

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.logoutData = response.data
          this.isLoadingLogout = false
          this.getNotification('Sucesso', 'Instância desconectada com sucesso!', 'success')
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoadingLogout = false

        if (!error.response) {
          this.logoutData = {
            status: 'ERRO',
            error: true,
            response: {
              message: 'Não foi possível conectar-se ao servidor.'
            }
          }
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.logoutData = {
            status: 'ERRO',
            error: true,
            response: {
              message: error.response.data.message || 'Erro ao desconectar instância'
            }
          }
        }
      }
    },

    async connectInstance(gateway) {
      this.selectedGateway = gateway
      this.isLoadingConnect = true
      this.showConnectModal = true
      this.connectData = null

      const url = `${config.default.urlBase}/evolution-api/instance/connect`
      const data = {
        url: gateway.baseUrl,
        apikey: gateway.apiKey,
        instanceName: gateway.gatewayInstanceName
      }

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.connectData = response.data
          this.isLoadingConnect = false
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoadingConnect = false

        if (!error.response) {
          this.getNotification('Erro', 'Não foi possível conectar-se ao servidor.', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.getNotification('Erro', `${error.response.data.message || 'Erro ao conectar instância'}`, 'error')
        }
      }
    },


    async sendTestMessage(gateway) {
      this.selectedGateway = gateway
      this.showSendTestMessageModal = true
      this.sendTestMessageData = null
      this.isLoadingSendTestMessage = false
      this.formTestMessage = {
        number: '',
        message: ''
      }
    },

    async submitTestMessage() {
      if (!this.selectedGateway || !this.formTestMessage.number || !this.formTestMessage.message) {
        this.getNotification('Aviso', 'Preencha todos os campos obrigatórios.', 'warning')
        return
      }

      this.isLoadingSendTestMessage = true
      this.sendTestMessageData = null

    
      let cleanNumber = this.formTestMessage.number.trim()
     
      if (cleanNumber.startsWith('+')) {
        cleanNumber = '+' + cleanNumber.substring(1).replace(/\D/g, '')
      } else {
        
        cleanNumber = cleanNumber.replace(/\D/g, '')
      }

      const url = `${config.default.urlBase}/evolution-api/instance/sendmessage`
      const data = {
        url: this.selectedGateway.baseUrl,
        apikey: this.selectedGateway.apiKey,
        instanceName: this.selectedGateway.gatewayInstanceName,
        message: this.formTestMessage.message,
        number: cleanNumber
      }

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.sendTestMessageData = {
            ...response.data,
            error: false
          }
          this.isLoadingSendTestMessage = false
          this.getNotification('Sucesso', 'Mensagem de teste enviada com sucesso!', 'success')
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoadingSendTestMessage = false

        if (!error.response) {
          this.sendTestMessageData = {
            error: true,
            message: 'Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!'
          }
          this.getNotification('Erro', 'Não foi possível conectar-se ao servidor.', 'error')
        } else if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else {
          this.sendTestMessageData = {
            error: true,
            message: error.response.data.message || 'Erro ao enviar mensagem de teste'
          }
          this.getNotification('Erro', error.response.data.message || 'Erro ao enviar mensagem de teste', 'error')
        }
      }
    },


    closeSendTestMessageModal() {
      this.showSendTestMessageModal = false
      this.sendTestMessageData = null
      this.selectedGateway = null
      this.isLoadingSendTestMessage = false
      this.formTestMessage = {
        number: '',
        message: ''
      }
    },

    closeStatusModal() {
      this.showStatusModal = false
      this.statusData = null
      this.selectedGateway = null
    },

    closeLogoutModal() {
      this.showLogoutModal = false
      this.logoutData = null
      this.selectedGateway = null
    },

    closeConnectModal() {
      this.showConnectModal = false
      this.connectData = null
      this.selectedGateway = null
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')
    await this.getApps()
    this.isLoading = false
  },
  computed: {
    isSearching() {
      return this.isBusy && this.selectedAppOption
    },
    showSelectAppMessage() {
      return !this.selectedAppOption && this.items.length === 0 && !this.isBusy
    },
    showValidationEmptyMessage() {
      return !this.isBusy && this.items.length === 0 && this.selectedAppOption
    }
  }
}
